import { useNavigate } from "react-router-dom";
import { Play, Clock } from "lucide-react";
import { fileUrl } from "../lib/api";

const VIBE_GRADIENT = {
  nostalgic: "from-amber-700/60 to-rose-900/80",
  hype: "from-red-600/60 to-orange-900/80",
  cinematic: "from-slate-700/60 to-black/90",
  emotional: "from-purple-800/60 to-rose-950/90",
};

export const PosterCard = ({ episode, index = 0 }) => {
  const navigate = useNavigate();
  const coverId = episode.media_ids?.[0];
  const vibeGrad = VIBE_GRADIENT[episode.vibe] || VIBE_GRADIENT.cinematic;

  return (
    <button
      data-testid={`episode-poster-${episode.id}`}
      onClick={() => navigate(`/watch/${episode.id}`)}
      className="group w-[240px] sm:w-[280px] aspect-[2/3] snap-center shrink-0 relative overflow-hidden rounded-sm poster-shadow text-left"
    >
      {coverId ? (
        <img
          src={fileUrl(coverId)}
          alt={episode.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      ) : (
        <div className={`absolute inset-0 bg-gradient-to-br ${vibeGrad}`} />
      )}
      <div className={`absolute inset-0 bg-gradient-to-t ${vibeGrad} mix-blend-multiply opacity-70`} />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />

      {/* Status badge */}
      <div className="absolute top-3 left-3 z-10">
        {episode.status === "generating" && (
          <span className="font-mono text-[10px] uppercase tracking-widest bg-[#FF2A2A]/90 text-white px-2 py-1 inline-flex items-center gap-1.5">
            <Clock className="w-3 h-3 animate-spin" /> Rendering
          </span>
        )}
        {episode.status === "ready" && (
          <span className="font-mono text-[10px] uppercase tracking-widest bg-white/10 backdrop-blur text-white/80 px-2 py-1">
            Ep {String(index + 1).padStart(2, "0")}
          </span>
        )}
        {episode.status === "failed" && (
          <span className="font-mono text-[10px] uppercase tracking-widest bg-yellow-500/90 text-black px-2 py-1">
            Retry
          </span>
        )}
      </div>

      {/* Title */}
      <div className="absolute bottom-0 left-0 right-0 p-5 z-10">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50 mb-2">
          {episode.vibe}
        </div>
        <h3 className="font-display font-black text-2xl tracking-tight leading-tight text-white">
          {episode.title}
        </h3>
        {episode.script?.tagline && (
          <p className="font-emotional text-sm text-white/70 mt-2 line-clamp-2">
            {`"${episode.script.tagline}"`}
          </p>
        )}
      </div>

      {/* Hover play */}
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/40 z-20">
        <div className="w-16 h-16 rounded-full bg-[#FF2A2A] flex items-center justify-center">
          <Play className="w-7 h-7 text-white fill-white ml-1" />
        </div>
      </div>
    </button>
  );
};
